import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Link,
  Alert,
  CircularProgress
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import FirebaseService from '../services/FirebaseService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess(false);
    
    try {
      await FirebaseService.sendPasswordResetEmail(email);
      setSuccess(true);
    } catch (err) {
      // Removed console.error
      setError(err.message || 'Failed to send password reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'flex-start', 
      justifyContent: 'center',
      bgcolor: '#f5f5f5',
      py: 4,
      pt: 8
    }}>
      <Container maxWidth="sm">
        <Paper 
          elevation={1} 
          sx={{ 
            p: 4, 
            borderRadius: 2
          }}
        >
          <Typography variant="h4" component="h1" align="center" gutterBottom>
            Forgot Password
          </Typography>
          
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            Enter your email address to receive a password reset link
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}
          
          {success && (
            <Alert severity="success" sx={{ mb: 3 }}>
              Password reset email sent! Check your inbox for further instructions.
            </Alert>
          )}
          
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading || success}
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              disabled={loading || success}
              startIcon={loading ? <CircularProgress size={24} color="inherit" /> : <EmailIcon />}
              sx={{ mt: 3, mb: 2, height: '56px' }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Link component={RouterLink} to="/login" variant="body2">
                Back to Login
              </Link>
              <Link component={RouterLink} to="/register" variant="body2">
                Create new account
              </Link>
            </Box>
          </Box>
        </Paper>
        
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Link component={RouterLink} to="/" variant="body2">
            Back to Certificate Verification
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
